import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import dompurify from "isomorphic-dompurify";
import { __, customPaymentMethods } from "@jti/fe-common";
import { useSelector } from "@jti/store";
import { useAemModel } from "../../../../contexts/AemModelContext";
import styles from "./Order.module.scss";
const { sanitize } = dompurify;
const OrderPaymentMethod = ({ paymentMethod }) => {
    const aemModel = useAemModel();
    const isPayOnDeliveryOrder = useSelector((state) => state.order.orderDetails.data?.paymentMethod === customPaymentMethods.payOnDelivery);
    if (isPayOnDeliveryOrder) {
        return (_jsx("div", { "data-testid": "pay-on-delivery-message", dangerouslySetInnerHTML: {
                __html: sanitize(aemModel.payOnDelivery.paymentMethod),
            } }));
    }
    if (paymentMethod) {
        return (_jsxs("div", { "data-testid": "payment-method", className: styles.paymentMethod, children: [paymentMethod.icon && _jsx("img", { src: paymentMethod.icon, className: styles.paymentMethodImg }), paymentMethod.title] }));
    }
    return _jsx("div", { children: __("cart.order.payment_method.na") });
};
export default OrderPaymentMethod;
//# sourceMappingURL=OrderPaymentMethod.js.map